import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const PROGRAMS = [
  {
    to: "/join/sales-team",
    tag: "Tier 00 · Elite",
    title: "Power Sales Team",
    desc: "Close $250K+/yr. Earn 22% commission with Delaware C-Corp ownership pathway. Mobile-first, worldwide.",
    accent: true,
  },
  {
    to: "/join/haulers",
    tag: "Tier 01 · Operations",
    title: "Preferred Haulers",
    desc: "Bonded carriers and tow operators get high-margin dispatch leads inside their service area. Join the affiliate network.",
  },
  {
    to: "/join/affiliates",
    tag: "Tier 02 · Marketing",
    title: "Marketing Affiliates",
    desc: "Influencers, brokers, channel partners. Recurring commission on every booking you refer.",
  },
  {
    to: "/join/link-sharing",
    tag: "Tier 03 · Publishers",
    title: "Link Sharing Program",
    desc: "Directories, blogs, classifieds. Share branded links — earn per qualified click and per booking.",
  },
];

export default function JoinHub() {
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="join-hub">
      <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#D97706]">// Disposal Affiliate Network</div>
      <h1 className="display-black text-5xl lg:text-6xl uppercase text-[#064E3B] mt-3 tracking-tighter">
        Join us. Four programs.
      </h1>
      <p className="text-gray-700 mt-4 max-w-2xl">
        Earn alongside the largest removal network in North America — expanding worldwide. Choose your tier.
      </p>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-px bg-gray-300 border border-gray-300">
        {PROGRAMS.map(p => (
          <Link
            key={p.to}
            to={p.to}
            className={`${p.accent ? "bento-card-dark" : "bento-card"} p-8`}
            data-testid={`join-hub-${p.to.split("/").pop()}`}
          >
            <div className={`mono text-[10px] tracking-[0.22em] uppercase ${p.accent ? "text-[#FACC15]" : "text-[#D97706]"}`}>{p.tag}</div>
            <h3 className={`display-black text-2xl uppercase mt-3 ${p.accent ? "text-white" : "text-[#064E3B]"}`}>{p.title}</h3>
            <p className={`text-sm mt-3 ${p.accent ? "text-white/80" : "text-gray-700"}`}>{p.desc}</p>
            <div className={`mono text-[11px] tracking-wider uppercase mt-6 flex items-center gap-2 ${p.accent ? "text-[#FACC15]" : "text-[#064E3B]"}`}>
              Apply <ArrowRight className="w-3 h-3" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
